/** RP-3 Option A — pure rules for the post-activation prompt and the ACTIVE-row schedule chip. No API access. */
export const canOpenScheduleHome = (perms = []) => ['services.manage', 'roster.manage'].some((p) => perms.includes(p));

/** Chip for an ACTIVE agreement row from GET /agreements/{id}/schedules → { schedules, shifts, unfilled } totals. */
export const scheduleChip = (agreement, info) => {
  if (!agreement || (agreement.effective_status || agreement.status) !== 'ACTIVE') return null;
  const lines = info?.lines || [];
  const schedules = lines.reduce((n, l) => n + (l.schedule_count || 0), 0);
  const shifts = lines.reduce((n, l) => n + (l.shifts || 0), 0);
  const unfilled = lines.reduce((n, l) => n + (l.unfilled || 0), 0);
  if (!info) return { label: 'Schedules: …', tone: 'muted', action: false };
  if (schedules === 0) return { label: 'No schedule yet', tone: 'amber', action: true, hint: 'Create the first participant schedule from an agreement line' };
  return { label: `${schedules} schedule(s) · ${shifts} shift(s)${unfilled ? ` · ${unfilled} unfilled` : ''}`, tone: 'emerald', action: true, hint: 'Open the Schedule home' };
};

/** Toast options after a successful activation: the "Schedule now" action is offered only when the user can schedule. */
export const activationToast = (perms, onOpen) => (canOpenScheduleHome(perms) && onOpen
  ? { duration: 10000, action: { label: 'Schedule now', onClick: onOpen } }
  : undefined);
